export const Route = createFileRoute({
	// beforeLoad: () => {
	//   // Redirect to profile page by default
	//   throw redirect({
	//     to: '/settings/profile'
	//   })
	// },
});
